// ✅ Только свой TURN (он умеет и в STUN, и в TURN)
export const rtcConfig = {
    iceServers: [
        {
            // Свой сервер как STUN
            urls: 'stun:194.58.126.29:3478'
        },
        {
            // Свой сервер как TURN (UDP — основной)
            urls: 'turn:194.58.126.29:3478?transport=udp',
            username: 'webrtc',
            credential: '6t87hUG7hgth67YUgth7GfytRg67htiujykJhiUGYtr7fDfGtb'
        },
        {
            // Свой сервер как TURN (TCP — fallback за жёсткими файрволами)
            urls: 'turn:194.58.126.29:3478?transport=tcp',
            username: 'webrtc',
            credential: '6t87hUG7hgth67YUgth7GfytRg67htiujykJhiUGYtr7fDfGtb'
        }
    ],
    iceCandidatePoolSize: 10
};
